export default function Dashboard(){
  return(
    <div>
      slick dashboard soon! 
    </div>
  );
}